<google-map
  [width]="width"
  [height]="height() ?? '400px'"
  [center]="center"
  [zoom]="zoom"
  [options]="mapOptions">
  @for (workplace of workplacesList(); track workplace.workplaceId) {
    @if (hasLatLng(workplace)) {
      <map-marker
        #marker="mapMarker"
        [position]="getLatLng(workplace)"
        [options]="markerOptions"
        (mapClick)="openInfoWindow(workplace, marker)" />
    }
  }
  <map-info-window>{{ infoContent }}</map-info-window>
</google-map>
